export default {
  filterSearchBarPlaceholder: {
    id: 'FILTER_SEARCH_BAR_PLACEHOLDER',
    description: 'Placeholder for the search bar',
    defaultMessage: 'Search',
  },
};
